<template>
  <el-container style="width: 100%; height: 100%;">
    <lx-navigator nav-title="汽车维修培训" nav-active="1-1" :menuItems="menuItems"></lx-navigator>
    <el-main style="padding: 0 10px; height: 100%; ">
      <el-row class="lx-right-title">
        <el-col>汽车维修培训-项目模型</el-col>
      </el-row>
      <el-row class="lx-right-sub-title">
        <el-col :span="20"><i></i>项目模型列表</el-col>
        <el-col :span="4" style="text-align: right">
          <el-button type="primary" size="small" @click="addModel">添加项目模型</el-button>
        </el-col>
      </el-row>

      <el-row style="height: calc(100% - 110px); background-color: #fff; padding: 10px; overflow-y: auto">
        <el-col :span="24">
          <el-table :data="projectData" size="medium" border class="lx-table" row-class-name="lx-table-row" header-cell-class-name="lx-table-header-cell" cell-class-name="lx-table-cell">
            <el-table-column prop="resourceId" label="资源编号" align="center"></el-table-column>
            <el-table-column prop="name" label="资源名称" align="center"></el-table-column>
            <el-table-column prop="type" label="资源类型" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.type === 1">模型</span>
              </template>
            </el-table-column>
            <el-table-column label="添加时间" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.cts | formatHour}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="editModel(scope)">编辑</el-button>
                <!--<el-button type="text">删除</el-button>-->
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="closeDialog" width="750px" class="lx-dialog">
            <el-form label-width="120px" ref="handleModelForm" :model="handleModelForm" :rules="ruleForm">
              <el-form-item label="资源名称" prop="name">
                <el-input v-model="handleModelForm.name" class="form-inner" placeholder="资源名称"></el-input>
              </el-form-item>
              <el-form-item label="资源类型" prop="type">
                <template>
                  <el-radio v-model="handleModelForm.type" label="1" style="margin-left: 10px;">模型</el-radio>
                </template>
              </el-form-item>
              <el-form-item label="上传资源" prop="resource" style="height: 80px" class="lx-upload">
                <el-upload ref="upload" action="123" :auto-upload="false" :on-change="dealFile"  :file-list="fileList" :limit="1" style="margin-left: 10px; ">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip" style="display: inline-block;color: #C0C0C0;margin-left: 10px;">只能上传CNI/OBJ文件，且不超过100M</div>
                </el-upload>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
            <el-button @click="cancelModel('handleModelForm')">取 消</el-button>
            <el-button v-if="dialogTitle === '添加项目模型'" type="primary" @click="sureAddModel('handleModelForm')" :disabled="isBtnDisabled">确 定</el-button>
              <el-button v-else type="primary" @click="sureEditModel('handleModelForm')" :disabled="isBtnDisabled">确 定</el-button>
          </span>
          </el-dialog>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import Navigator from '@/components/common/Navigator'
export default {
  components: { 'lx-navigator': Navigator },
  data () {
    return {
      menuItems: [
        { index: '1-1', name: '项目模型', route: {name: 'ProjectModelManager'} },
        { index: '1-2', name: '测量工具', route: {name: 'MeasuringToolManager'} }
      ],
      nowIndex: 0,
      projectData: [
      ],
      isBtnDisabled: false,
      dialogVisible: false,
      dialogTitle: '添加项目模型',
      handleModelForm: {
        name: '',
        type: '1'
      },
      files: {},
      fileList: [],
      // 编辑参数
      id: '',
      resource_id: '',
      ruleForm: {
        name: [
          { required: true, message: '请输入资源名称', trigger: 'blur' },
          { min: 1, max: 10, message: '不能超过10个字符', trigger: 'blur' }
        ],
        resource: [
          { required: true, message: '请选择上传资源', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData () {
      this.$xhrGet(`/resource/models`).then(rs => {
        if (rs.code === 200) {
          this.projectData = rs.data
        }
      })
    },
    addModel () {
      this.dialogTitle = '添加项目模型'
      this.fileList = []
      this.files = {}
      this.handleModelForm.name = ''
      this.dialogVisible = true
      this.isBtnDisabled = false
    },
    editModel (scope) {
      this.dialogTitle = '编辑项目模型'
      this.handleModelForm.name = scope.row.name
      this.id = scope.row.id
      this.resource_id = scope.row.resourceId
      this.fileList = [{name: scope.row.resourceName}]
      this.files = {}
      this.dialogVisible = true
      this.isBtnDisabled = false
    },
    sureAddModel () {
      let forms = new FormData()
      forms.append('file', this.files)
      forms.append('name', this.handleModelForm.name)
      forms.append('type', this.handleModelForm.type)
      if (this.handleModelForm.name === '') {
        this.$message.error('资源名称不能为空!')
      } else {
        if (this.handleModelForm.name.length > 10) {
          this.$message.error('资源名称不能超过10个字符!')
        } else {
          if (this.fileList.length === 0) {
            this.$message.error('资源文件不能为空!')
          } else {
            this.isBtnDisabled = true
            this.$xhrFilePost(`/resource/models`, forms).then(rs => {
              if (rs.code === 200) {
                this.dialogVisible = false
                this.$refs['handleModelForm'].resetFields()
                this.initData()
              } else {
                this.isBtnDisabled = false
              }
              if (rs.code === 409) {
                this.$message.error('资源名称不能重复!')
              }
              if (rs.code === 400) {
                this.$message.error('输入内容不能为空格!')
              }
            })
          }
        }
      }
    },
    sureEditModel () {
      let forms = new FormData()
      forms.append('file', this.files)
      forms.append('name', this.handleModelForm.name)
      forms.append('type', this.handleModelForm.type)
      if (this.handleModelForm.name === '') {
        this.$message.error('资源名称不能为空!')
      } else {
        if (this.handleModelForm.name.length > 10) {
          this.$message.error('资源名称不能超过10个字符!')
        } else {
          if (this.fileList.length === 0) {
            this.$message.error('资源文件不能为空!')
          } else {
            this.isBtnDisabled = true
            this.$xhrFilePut(`/resource/models/${this.id}`, forms).then(rs => {
              if (rs.code === 200) {
                this.dialogVisible = false
                this.$refs['handleModelForm'].resetFields()
                this.initData()
              } else {
                this.isBtnDisabled = false
              }
              if (rs.code === 409) {
                this.$message.error('资源名称不能重复!')
              }
              if (rs.code === 400) {
                this.$message.error('输入内容不能为空格!')
              }
            })
          }
        }
      }
    },
    closeDialog () {
      this.dialogVisible = false
      this.$refs['handleModelForm'].resetFields()
      this.$refs.upload.clearFiles()
    },
    dealFile (file, fileList) {
      let resultIndex = file.name.indexOf('.')
      let fileType = file.name.slice(resultIndex + 1)
      const fileSize = file.size / 1024 / 1024 < 100
      if (fileType !== 'cni' && fileType !== 'obj') {
        this.$message.error('上传的文件只能是 CNI/OBJ 格式!')
        this.$refs.upload.clearFiles()
      }
      if (!fileSize) {
        this.$message.error('上传的文件大小不能超过100M!')
        this.$refs.upload.clearFiles()
      }
      if ((fileType === 'cni' || fileType === 'obj') && fileSize) {
        this.files = file.raw
        this.fileList = fileList
      }
    },
    cancelModel (form) {
      this.dialogVisible = false
      this.$refs[form].resetFields()
      this.$refs.upload.clearFiles()
    }
  }
}
</script>

<style scoped>
/deep/ .el-input__inner { border: 0; }
.lx-upload /deep/ .el-form-item__label { height: 100%; line-height: 80px; }
/deep/ .el-upload-list { width: 200px; }
</style>



// WEBPACK FOOTER //
// src/components/resource/ProjectModelManager.vue